import { render, staticRenderFns } from "./NonAuthenticatedParent.vue?vue&type=template&id=45ce8b96"
import script from "./NonAuthenticatedParent.vue?vue&type=script&lang=ts"
export * from "./NonAuthenticatedParent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports